<header class="app-titulo-pagina">
  <span>Novo Pagamento</span>
</header>

<!-- Spinner -->
<div *ngIf="mainService.pagamentoService.processando" class="text-center">
  <i class="fa fa-spinner fa-pulse fa-4x"></i>
</div>
<!-- Spinner -->

<div *ngIf="!mainService.pagamentoService.processando">

  <!-- Container validar pagamento e form -->
  <div class=" container app-panel">
    <div class="panel-body">
      <div class="well col-xs-12 col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2">
        <!-- Validar pagamento -->
        <h4>Novo pagamento</h4>
        <label *ngIf="mainService?.pagamentoService?.pagamentoIndividual.barcodeDetails?.type">
          {{mainService?.pagamentoService?.pagamentoIndividual?.barcodeDetails?.type === enumTipoBoleto.ARRECADACAO ?
          'Conta Consumo'
          :'Boleto'}}</label>

        <div style="display: flex; flex-direction: column; align-items: center; width: 100%;">
          <input class="form-control" style="margin-bottom: 10px;" type="text" name="inputLinhaDigitavel"
            [(ngModel)]="inputLinhaDigitavel" (keydown.enter)="$event.preventDefault()"
            placeholder="Ex: 00000.00000 00000.000000 00000.000000 0 00000000000000"
            [readonly]="mainService?.pagamentoService?.pagamentoIndividual?.status === enumStatusBoleto.NAO_PAGO" />
        </div>

        <div *ngIf="mainService?.pagamentoService?.pagamentoIndividual?.status"
          style="white-space: nowrap; margin-top: 1rem; margin-bottom: .5rem"><b>Status: </b>
          {{ getStatusFormatado(mainService?.pagamentoService?.pagamentoIndividual?.status) }}
          <i [ngSwitch]="mainService?.pagamentoService?.pagamentoIndividual?.status" style="margin-left: 2px;">
            <i *ngSwitchCase="enumStatusBoleto.NAO_PAGO" class="fa fa-check text-success fa-lg"></i>
            <i *ngSwitchDefault class="fa fa-times text-danger fa-lg"></i>
          </i>
        </div>
        <button
          *ngIf="mainService?.pagamentoService?.pagamentoIndividual?.status && mainService?.pagamentoService?.pagamentoIndividual?.status !== enumStatusBoleto.NAO_PAGO"
          id="excluir-boleto" type="button" (click)="deletePagamento()" class="btn app-btn-best"
          style="height: fit-content; margin-top: 1rem">
          <i class="fa fa-trash"></i>
          Limpar
        </button>
        <!-- Fim Validar pagamento -->

        <!-- Form do pagamento -->
        <div
          *ngIf="mainService?.pagamentoService?.pagamentoIndividual?.status && mainService?.pagamentoService?.pagamentoIndividual?.status === enumStatusBoleto.NAO_PAGO">
          <form (submit)="payBoleto()">
            <div class="panel-body">
              <div class="form-group col-xs-12 col-sm-6 col-md-6">
                <label for="data">Data de vencimento</label>
                <input type="text" id="data" class="form-control input-sm"
                  [value]="mainService?.pagamentoService?.pagamentoIndividual?.paymentInfo?.dueDate ? (mainService?.pagamentoService?.pagamentoIndividual?.paymentInfo?.dueDate | dateFormat:'':'dd/MM/yyyy') : 'Não informada'"
                  readonly>
              </div>
              <div class="form-group col-xs-12 col-sm-6 col-md-6">
                <label for="valor-total-documento">Valor do documento(R$)</label>
                <input type="text" id="valor-total-documento" class="form-control input-sm"
                  [value]="mainService?.pagamentoService?.pagamentoIndividual?.barcodeDetails?.value" readonly>
              </div>
              <div
                *ngIf="mainService?.pagamentoService?.pagamentoIndividual.barcodeDetails?.type === enumTipoBoleto.SIMPLES"
                class="form-group col-xs-12 col-sm-6 col-md-6">
                <label for="valor-total-pagamento">Valor do pagamento(R$)</label>
                <input type="text" id="valor-total-pagamento" class="form-control input-sm" name="valor-total-pagamento"
                  [(ngModel)]="mainService?.pagamentoService?.pagamentoIndividual?.paymentInfo.originalValue"
                  (ngModelChange)="calculaTotais()" uiMoeda
                  [readonly]="mainService?.pagamentoService?.pagamentoIndividual?.barcodeDetails?.value != 0">
              </div>
              <div
                *ngIf="mainService?.pagamentoService?.pagamentoIndividual.barcodeDetails?.type === enumTipoBoleto.SIMPLES"
                class="form-group col-xs-12 col-sm-6 col-md-6">
                <label for="valor-total-desconto">Valor do desconto(R$)</label>
                <input type="text" id="valor-total-desconto" class="form-control input-sm" name="valor-total-desconto"
                  [(ngModel)]="mainService?.pagamentoService?.pagamentoIndividual?.paymentInfo.totalDiscountValue"
                  (ngModelChange)="calculaTotais()" uiMoeda
                  [readonly]="mainService?.pagamentoService?.pagamentoIndividual?.barcodeDetails?.value == 0">
              </div>
              <div class="form-group col-xs-12 col-sm-6 col-md-4">
                <label for="valor-total-moeda">Total(R$)</label>
                <input type="text" id="valor-total-moeda" class="form-control input-sm text-left"
                  [value]="mainService?.pagamentoService?.pagamentoIndividual?.paymentInfo?.totalUpdatedValue" uiMoeda
                  readonly>
              </div>
              <div class="form-group col-xs-12 col-sm-6 col-md-4">
                <label for="valor-total-pontos">Total em pontos</label>
                <input type="text" id="valor-total-pontos" class="form-control input-sm text-left"
                  [value]="mainService?.pagamentoService?.pagamentoIndividual?.valuePoints" readonly>
              </div>
              <div class="form-group col-xs-12 col-sm-6 col-md-4">
                <label for="inputDescricao">Descrição </label>
                <input #inputObs type="text" class="form-control input-sm" name="inputDescricao" required
                  autocomplete="off" id="inputDescricao" maxlength="30" (click)="clearTextoInicialDescricao()"
                  [(ngModel)]="mainService.pagamentoService.pagamentoIndividual.observacao">
                <div *ngIf="!mainService?.pagamentoService?.pagamentoIndividual?.observacao" class="text-danger"
                  style="font-size: 10px;">
                  Campo obrigatório
                </div>
              </div>
              <div class="form-group col-xs-12 col-sm-6 col-md-6 col-md-offset-3">
                <label for="ep">Senha eletrônica </label>
                <input type="password" id="ep" class="form-control input-sm" name="ep" [(ngModel)]="ep">
              </div>
              <div class="col-xs-12 text-center">
                <a (click)="mainService.loginService.changeRoute('/pagamentos'); deletePagamento()"
                  class="btn btn-danger-v2 ">
                  Voltar
                </a>
                <button id="confirmar-pagamento" type="submit" class="btn btn-success-v2" style="height: fit-content;">
                  Confirmar
                </button>
              </div>
            </div>
          </form>
        </div>
        <!-- Fim form do pagamento -->
      </div>
    </div>
  </div>
  <!-- Fim container validar pagamento e form -->

  <!-- Container regras e botões de pagamento -->
  <div class="container" *ngIf="!mainService.pagamentoService.processando">

    <!-- Regras de pagamentos -->
    <div *ngIf="mainService?.pagamentoService?.pagamentoIndividual?.status !== enumStatusBoleto.NAO_PAGO"
      class="col-xs-12 text-left">
      <div class="alert alert-warning" role="alert">
        <br />
        <p><i class="fa fa-exclamation-triangle" aria-hidden="true">
          </i> O horário limite para pagamento é às <strong>17h00</strong>. Pagamentos
          enviados após esse horário <strong>não serão aceitos.</strong></p>
        <br />
        <p>
          <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
          Não enviamos comprovantes de pagamentos por email. O mesmo estará
          disponível para impressão após a compensação através da opção
          <strong>extrato</strong>.
        </p>
        <br />
        <p>
          <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Não
          serão aceitos pagamentos com <strong>juros</strong>.
        </p>
        <br />
        <p>
          <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> São
          aceitos pagamentos de boletos com <strong>desconto</strong>.
        </p>
        <br />
        <p><i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
          São aceitos pagamentos de <strong>conta de consumo, boletos, IPVA, DARF e multas de trânsito</strong>, .
        </p>
        <br>
        <p>
          <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
          <strong>Taxa de Serviço: 0 pontos.</strong>
        </p>
      </div>

    </div>
    <!-- Fim regras de pagamentos -->

    <!-- Botões de ações -->
    <div class="col-xs-12 text-center" style="padding-bottom: 15px;">
      <a *ngIf="mainService?.pagamentoService?.pagamentoIndividual?.status !== enumStatusBoleto.NAO_PAGO"
        (click)="mainService.loginService.changeRoute('/pagamentos')" id="btn-voltar" class="btn btn-danger-v2">
        Voltar
      </a>
      <button *ngIf="mainService?.pagamentoService?.pagamentoIndividual?.status !== enumStatusBoleto.NAO_PAGO"
        type="button" (click)="validatePagamento()" data-dismiss="modal" class="btn btn-success-v2"
        style="height: fit-content;" [disabled]="!inputLinhaDigitavel">
        <i class="fa fa-plus-circle"></i>
        Validar
      </button>
    </div>
    <!-- Botões de ações -->
  </div>
  <!-- Fim Container regras e botões de ações -->
</div>


// WEBPACK FOOTER //
// ./src/app/pagamento/novo-pagamento-individual/novo-pagamento-individual.component.html